exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeleteMemberModal-module__wrapper___2ncKq{display:grid;gap:1rem}.DeleteMemberModal-module__wrapper___2ncKq img{max-width:200px;margin:0 auto;display:flex;justify-content:center}.DeleteMemberModal-module__wrapper___2ncKq h2{line-height:1}.DeleteMemberModal-module__wrapper___2ncKq .DeleteMemberModal-module__button-wrapper___3O2su{display:grid;justify-content:end;gap:.75rem;grid-auto-flow:column}", ""]);

// exports
exports.locals = {
	"wrapper": "DeleteMemberModal-module__wrapper___2ncKq",
	"button-wrapper": "DeleteMemberModal-module__button-wrapper___3O2su"
};